<template>
  <div>
    <div class="hottest-savings-section w-100 d-inline-block position-relative overflow-hidden py-5">
      <!-- Background Pattern -->
      <div class="savings-bg-pattern position-absolute w-100 h-100 top-0 left-0"></div>

      <!-- Floating Images -->
      <img v-lazy="require('@/assets/images/food-1.png')" class="floating-img img-1 d-none d-lg-block" alt="dog food">
      <img v-lazy="require('@/assets/images/food-2.png')" class="floating-img img-2 d-none d-lg-block" alt="pet treats">
      <img v-lazy="require('@/assets/images/food-3.png')" class="floating-img img-3 d-none d-lg-block" alt="cat treats">
      <img v-lazy="require('@/assets/images/food-4.png')" class="floating-img img-4 d-none d-lg-block" alt="bird food">
      <img v-lazy="require('@/assets/images/food-5.png')" class="floating-img img-5 d-none d-lg-block" alt="rabbit food">
      <img v-lazy="require('@/assets/images/food-6.png')" class="floating-img img-6 d-none d-lg-block" alt="grooming product">

      <div class="container autoContent position-relative z-1">
        <div class="row justify-content-center text-center">
          <div class="col-xl-8 col-lg-10 col-12">
            <div class="savings-content py-4">
              <p class="mb-2 text-size-14 txt-gray family-filson-bold text-uppercase tracking-widest">
                Taste of the wild
              </p>
              <h2 class="text-black fw-bold text-size-36 family-filson-bold mb-3">
                Hottest Savings Have Arrived!
              </h2>
              <p class="text-size-15 text-black family-inter-light mb-4 px-md-5 mx-xl-5 lh-base">
                If you're getting a new dog, you're going to need things like a leash, collar, and crate, so we've put together a list of supplies for new.
              </p>
              <div class="mt-2">
                <a class="shop-now-btn text-white text-size-14 d-inline-block text-uppercase bg-orange inter-semi-bold px-5 py-3 rounded-2 text-decoration-none shadow-sm" href="javascript:void(0)">
                  Shop Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'petsProteenComponent',
}
</script>

<style scoped>
.hottest-savings-section {
  background-color: #f8f9fa;
  min-height: 400px;
  display: flex;
  align-items: center;
}

.savings-bg-pattern {
  background-image: url('@/assets/images/pets-bg-image.svg');
  background-size: 400px;
  opacity: 0.05;
  pointer-events: none;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.bg-orange {
  background-color: #fd7e14 !important;
}

.txt-gray {
  color: #7E7E7E !important;
}

.text-size-36 { font-size: 36px; }
.text-size-15 { font-size: 15px; }

.shop-now-btn {
  transition: all 0.3s ease;
}

.shop-now-btn:hover {
  background-color: #e86b00 !important;
  transform: translateY(-2px);
}

/* Floating Images Positioning */
.floating-img {
  position: absolute;
  width: 100px;
  height: auto;
  object-fit: contain;
  z-index: 0;
  transition: transform 0.3s ease;
}

.img-1 { top: 15%; left: 8%; transform: rotate(-15deg); width: 90px; } /* Toy */
.img-2 { top: 45%; left: 5%; transform: rotate(10deg); width: 100px; } /* Treats */
.img-3 { bottom: 10%; left: 15%; transform: rotate(-5deg); width: 120px; } /* Food bag 1 */
.img-4 { top: 10%; right: 10%; transform: rotate(15deg); width: 120px; } /* Food bag 2 */
.img-5 { top: 50%; right: 8%; transform: rotate(-10deg); width: 95px; } /* Bottle */
.img-6 { bottom: 15%; right: 18%; transform: rotate(5deg); width: 120px; } /* Food bag 3 */

.floating-img:hover {
  transform: scale(1.1) rotate(0deg);
}

@media (max-width: 1199.98px) {
  .floating-img { width: 80px; }
  .img-1 { left: 5%; }
  .img-6 { right: 12%; }
}

@media (max-width: 991.98px) {
  .text-size-36 { font-size: 28px; }
}
</style>
